// Types
import { KycList, ListsType, PrivacyList, PrivacyListType } from "types/info";

export const CONDITIONS_LIST: ListsType = (project: "glory" | "banger") => {
  return [
    {
      id: 1,
      title: "tc.about.title",
      description: `tc.about.description.${project}`,
    },
    {
      id: 2,
      title: "tc.provisions.title",
      description: `tc.provisions.description.${project}`,
    },
    {
      id: 3,
      title: "tc.definitions.title",
      description: `tc.definitions.description.${project}`,
    },
    {
      id: 4,
      title: "tc.account.title",
      description: `tc.account.description.${project}`,
    },
    {
      id: 5,
      title: "tc.juvenile.title",
      description: `tc.juvenile.description.${project}`,
    },
    { id: 6, title: "tc.client.title", description: "tc.client.description" },
    {
      id: 7,
      title: "tc.registration.title",
      description: `tc.registration.description.${project}`,
    },
    {
      id: 8,
      title: "tc.winnings.title",
      description: `tc.winnings.description.${project}`,
    },
    {
      id: 9,
      title: "tc.legal.title",
      description: `tc.legal.description.${project}`,
    },
    {
      id: 10,
      title: "tc.rules.title",
      description: `tc.rules.description.${project}`,
    },
    {
      id: 11,
      title: "tc.password.title",
      description: "tc.password.description",
    },
    {
      id: 12,
      title: "tc.promotions.title",
      description: `tc.promotions.description.${project}`,
    },
    {
      id: 12,
      title: "tc.bonus.deposite.title",
      description: `tc.bonus.deposite.description.${project}`,
    },
    { id: 13, title: "tc.bonus.title", description: "tc.bonus.description" },
    {
      id: 14,
      title: "tc.games.title",
      description: `tc.games.description.${project}`,
    },
    { id: 15, title: "tc.bets.title", description: "tc.bets.description" },
    { id: 16, title: "tc.type.title", description: "tc.type.description" },
    {
      id: 17,
      title: "tc.restriction.title",
      description: "tc.restriction.description",
    },
    {
      id: 18,
      title: "tc.funds.title",
      description: `tc.funds.description.${project}`,
    },
  ];
};

export const KYC_AML_LIST: KycList = (project: "glory" | "banger") => {
  return [
    {
      id: 1,
      title: "aml.cash.header",
      subTitle: "",
      description: `aml.cash.description.${project}`,
    },
    {
      id: 2,
      title: "aml.definition.title",
      subTitle: "",
      description: "aml.definition.description",
    },
    {
      id: 3,
      title: `aml.organization.title.${project}`,
      subTitle: "",
      description: `aml.organization.description.${project}`,
    },
    {
      id: 4,
      title: "aml.implementation.title",
      subTitle: "",
      description: `aml.implementation.description.${project}`,
    },
    {
      id: 5,
      title: "aml.verification.title",
      subTitle: "aml.verification.step.1",
      description: "aml.verification.description.1",
    },
    {
      id: 6,
      title: "",
      subTitle: "aml.verification.step.2",
      description: "aml.verification.description.2",
    },
    {
      id: 7,
      title: "",
      subTitle: "aml.verification.step.3",
      description: "aml.verification.description.3",
    },
    {
      id: 8,
      title: "aml.customer.title",
      subTitle: "",
      description: "aml.customer.description",
    },
    {
      id: 9,
      title: "aml.proof.title",
      subTitle: "",
      description: "aml.proof.description",
    },
    {
      id: 10,
      title: "aml.funds.title",
      subTitle: "",
      description: `aml.funds.description.${project}`,
    },
    {
      id: 11,
      title: "aml.basic.title",
      subTitle: "",
      description: "aml.basic.description",
    },
    {
      id: 12,
      title: "aml.risk.title",
      subTitle: "",
      description: `aml.risk.description.${project}`,
    },
    {
      id: 13,
      title: "",
      subTitle: "aml.risk.1",
      description: "aml.risk.description.1",
    },
    {
      id: 14,
      title: "",
      subTitle: "aml.risk.2",
      description: "aml.risk.description.2",
    },
    {
      id: 15,
      title: "",
      subTitle: "aml.risk.3",
      description: "aml.risk.description.3",
    },
    {
      id: 16,
      title: "aml.measurements.title",
      subTitle: "",
      description: `aml.measurements.description.${project}`,
    },

    {
      id: 17,
      title: "",
      subTitle: "aml.enterprise.sub.title",
      description: `aml.enterprise.description.${project}`,
    },
    {
      id: 18,
      title: "aml.transaction.title",
      subTitle: "",
      description: `aml.transaction.description.${project}`,
    },
    {
      id: 19,
      title: `aml.reporting.title.${project}`,
      subTitle: "",
      description: `aml.reporting.description.${project}`,
    },
    {
      id: 20,
      title: "aml.procedures.title",
      subTitle: "",
      description: `aml.procedures.description.${project}`,
    },
    {
      id: 21,
      title: "aml.record.title",
      subTitle: "",
      description: "aml.record.description",
    },
    {
      id: 22,
      title: "aml.training.title",
      subTitle: "",
      description: `aml.training.description.${project}`,
    },
    {
      id: 23,
      title: `aml.auditing.title.${project}`,
      subTitle: "",
      description: "aml.auditing.description",
    },
    {
      id: 24,
      title: "aml.security.title",
      subTitle: "",
      description: `aml.security.description.${project}`,
    },
    {
      id: 25,
      title: "aml.withdrawal.title",
      subTitle: "",
      description: `aml.withdrawal.description.${project}`,
    },
    {
      id: 26,
      title: "aml.refund.title",
      subTitle: "",
      description: `aml.refund.description.${project}`,
    },
    {
      id: 27,
      title: "aml.contact.title",
      subTitle: "",
      description: `aml.contact.description.${project}`,
    },
  ];
};

export const PRIVACY_LIST: PrivacyList = (project: "glory" | "banger") => [
  {
    id: 1,
    header: "privacy.header",
    title: "",
    description: `privacy.description.${project}`,
  },
  {
    id: 2,
    header: "privacy.collected.header",
    title: "",
    description: "privacy.collected.description",
  },
  {
    id: 3,
    header: "privacy.collecting.header",
    title: "",
    description: `privacy.collecting.description.${project}`,
  },
  {
    id: 4,
    header: "privacy.information.header",
    title: "",
    description: "privacy.information.description",
  },
  {
    id: 5,
    header: "privacy.certain.header",
    title: "",
    description: "privacy.certain.description",
  },
  {
    id: 6,
    header: "privacy.access.header",
    title: "",
    description: "privacy.access.description",
  },
  {
    id: 7,
    header: "privacy.cookies.header",
    title: "privacy.cookies.device.title",
    description: "privacy.cookies.device.description",
  },
  {
    id: 71,
    header: "",
    title: "privacy.cookies.strictly.title",
    description: "privacy.cookies.strictly.description",
  },
  {
    id: 72,
    header: "",
    title: "privacy.cookies.registration.title",
    description: "privacy.cookies.registration.description",
  },
  {
    id: 73,
    header: "",
    title: "privacy.cookies.website.title",
    description: "privacy.cookies.website.description",
  },
  {
    id: 74,
    header: "",
    title: "privacy.cookies.flash.title",
    description: "privacy.cookies.flash.description",
  },
  {
    id: 8,
    header: "privacy.providers.header",
    title: "",
    description: "privacy.providers.description",
  },
  {
    id: 9,
    header: "privacy.consent.header",
    title: "",
    description: "privacy.consent.description",
  },
  {
    id: 10,
    header: "privacy.security.header",
    title: "",
    description: "privacy.security.description",
  },
  {
    id: 11,
    header: "privacy.protection.header",
    title: "",
    description: "privacy.protection.description",
  },
  {
    id: 12,
    header: "privacy.transfers.header",
    title: "",
    description: "privacy.transfers.description",
  },
  {
    id: 13,
    header: "privacy.practices.header",
    title: "",
    description: "privacy.practices.description",
  },
  {
    id: 14,
    header: "privacy.disclaimer.header",
    title: "",
    description: "privacy.disclaimer.description",
  },
  {
    id: 15,
    header: "privacy.policy.header",
    title: "",
    description: "privacy.policy.description",
  },
  {
    id: 16,
    header: "privacy.other.header",
    title: "",
    description: "privacy.other.description",
  },
];

export const GAMBLE_LIST: PrivacyList = (project: "glory" | "banger") => {
  return [
    {
      id: 1,
      header: "",
      title: "",
      description: `gamble.description.${project}`,
    },
    {
      id: 2,
      header: "gamble.interdef.header",
      title: "gamble.interpretation.title",
      description: "gamble.interpretation.description",
    },
    {
      id: 3,
      header: "",
      title: "gamble.definitions.title",
      description: `gamble.definitions.description.${project}`,
    },
    {
      id: 4,
      header: "gamble.responsible.header",
      title: "gamble.responsible.title",
      description: "gamble.responsible.description",
    },
    {
      id: 5,
      header: "",
      title: "gamble.information.title",
      description: `gamble.information.description.${project}`,
    },
  ];
};

export const SECOND_GAMBLE_LIST: PrivacyList = (
  project: "glory" | "banger",
) => {
  return [
    {
      id: 6,
      header: "",
      title: `gamble.helpful.title.${project}`,
      description: "gamble.helpful.description",
    },
    {
      id: 7,
      header: "",
      title: "gamble.protection.title",
      description: "gamble.protection.description",
    },
  ];
};

export const COOKIES_LIST: PrivacyListType[] = [
  {
    id: 1,
    header: "",
    title: "cookies.information.title",
    description: "cookies.information.description",
  },
  {
    id: 2,
    header: "",
    title: "cookies.strictly.title",
    description: "cookies.strictly.description",
  },
  {
    id: 3,
    header: "",
    title: "cookies.during.title",
    description: "cookies.during.description",
  },
  {
    id: 4,
    header: "",
    title: "cookies.website.title",
    description: "cookies.website.description",
  },
  {
    id: 5,
    header: "",
    title: "cookies.flash.title",
    description: "cookies.flash.description",
  },
];
